var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenouilleres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_7",
    "data-name": "Calque 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 135.35 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-21,.cls-22,.cls-23{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#4c4c4c;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{opacity:0.4;}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_65);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_71);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_65-2);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_71-2);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_65-3);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_71-3);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_65-4);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_71-4);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_65-5);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_71-5);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_65-6);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_71-6);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_65-7);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_71-7);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_65-8);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_71-8);}.cls-20{fill:#666;opacity:0.69;}.cls-21,.cls-22,.cls-23,.cls-25{stroke-miterlimit:10;}.cls-21,.cls-22,.cls-23{stroke-width:4px;}.cls-21{stroke:url(#D\xE9grad\xE9_sans_nom_73);}.cls-22{stroke:url(#D\xE9grad\xE9_sans_nom_73-2);}.cls-23{stroke:url(#D\xE9grad\xE9_sans_nom_73-3);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_100);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_100-2);stroke:url(#D\xE9grad\xE9_sans_nom_73-4);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-878 -783)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1011,881c-1.07-5.55-3.33-9.74-9-10l-13-2v-2l13-1c3.59-.79,5.17-2.69,6-5l-1-20c-1.67-5.28-4-8-11-9l1-2h6c2.82-.44,4.4-1.9,4-5l-1-12c-6-19-36-29-60-30-24,1-54,11-60,30l-1,12c-.4,3.1,1.18,4.56,4,5h6l1,2c-7,1-9.33,3.72-11,9l-1,20c.83,2.31,2.41,4.21,6,5l13,1v2l-13,2c-5.67.26-7.93,4.45-9,10l-2,85c.51,4.82,2.66,7.28,6,8h122c3.34-.72,5.49-3.18,6-8Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65",
    x1: 910.17,
    y1: 881.38,
    x2: 918.56,
    y2: 881.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#555152",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8f888a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdb6b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_71",
    x1: 754.74,
    y1: 881.5,
    x2: 762.87,
    y2: 881.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 1679.87, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-2",
    x1: 895.58,
    y1: 832.94,
    x2: 899.59,
    y2: 833.01,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_71-2",
    x1: 775.59,
    y1: 833,
    x2: 780.87,
    y2: 833,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-3",
    x1: 894.62,
    y1: 963.44,
    x2: 898.18,
    y2: 963.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_71-3",
    x1: 776.59,
    y1: 963.5,
    x2: 781.87,
    y2: 963.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-4",
    x1: 892.79,
    y1: 910.65,
    x2: 899.75,
    y2: 910.77,
    gradientTransform: "translate(-101.71 109.85) rotate(-6.62)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_71-4",
    x1: 776.01,
    y1: 910.72,
    x2: 784.85,
    y2: 910.72,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, 1566.96, -83.77)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-5",
    x1: 891.88,
    y1: 881.38,
    x2: 900.27,
    y2: 881.53,
    gradientTransform: "matrix(-1, 0, 0, 1, 1879.74, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_71-5",
    x1: 773,
    y1: 881.5,
    x2: 781.13,
    y2: 881.5,
    gradientTransform: "translate(199.87)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-6",
    x1: 880.33,
    y1: 832.44,
    x2: 884.31,
    y2: 832.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 1879.74, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_71-6",
    x1: 790.85,
    y1: 832.5,
    x2: 796.13,
    y2: 832.5,
    gradientTransform: "translate(199.87)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-7",
    x1: 876.36,
    y1: 961.44,
    x2: 879.92,
    y2: 961.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 1879.74, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_71-7",
    x1: 794.85,
    y1: 961.5,
    x2: 800.13,
    y2: 961.5,
    gradientTransform: "translate(199.87)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-8",
    x1: 876.82,
    y1: 908.25,
    x2: 883.51,
    y2: 908.37,
    gradientTransform: "matrix(-0.99, -0.12, -0.12, 0.99, 1981.45, 109.85)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_71-8",
    x1: 792.24,
    y1: 908.32,
    x2: 800.77,
    y2: 908.32,
    gradientTransform: "translate(312.78 -83.77) rotate(6.62)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_73",
    x1: 946,
    y1: 833.98,
    x2: 946,
    y2: 826.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_73-2",
    y1: 870.98,
    y2: 863.09,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_73-3",
    y1: 954.97,
    y2: 945.09,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_73"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_100",
    x1: 946,
    y1: 974,
    x2: 946,
    y2: 783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#211f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#303030",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#303030",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_100-2",
    x1: 878.5,
    y1: 879,
    x2: 1012.5,
    y2: 879,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_100"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_73-4",
    x1: 945.5,
    y1: 975,
    x2: 945.5,
    y2: 783,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_73"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "genouill\xE8re") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1011,881c-1.07-5.55-3.33-9.74-9-10l-13-2v-2l13-1c3.59-.79,5.17-2.69,6-5l-1-20c-1.67-5.28-4-8-11-9l1-2h6c2.82-.44,4.4-1.9,4-5l-1-12c-6-19-36-29-60-30-24,1-54,11-60,30l-1,12c-.4,3.1,1.18,4.56,4,5h6l1,2c-7,1-9.33,3.72-11,9l-1,20c.83,2.31,2.41,4.21,6,5l13,1v2l-13,2c-5.67.26-7.93,4.45-9,10l-2,85c.51,4.82,2.66,7.28,6,8h122c3.34-.72,5.49-3.18,6-8Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M917,971V792c-2.78,2-4,4.09-4,10.23,0,0-5,158.54-4,162.63S917,971,917,971Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M917,971V792c2.78,2,4,4.09,4,10.23,0,0,5,158.54,4,162.63S917,971,917,971Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M899,867V799c-2.78,1.92-3,5-3,11,0,0-1,49,0,53S899,867,899,867Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M899,867V799c2.78,1.92,4,4,4,10,0,0,2,49,1,53A7.27,7.27,0,0,1,899,867Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M898,974V953c-2.78.59-3,1.54-3,3.4,0,0-1,15.13,0,16.36A4.29,4.29,0,0,0,898,974Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M898,974V953c2.78.59,4,1.24,4,3.09,0,0,2,15.13,1,16.37S898,974,898,974Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M896.91,951l-3.81-79.94c-2.64,3.3-2.68,7-2.35,14.06,0,0,1.76,58,3,62.3S896.91,951,896.91,951Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M896.91,951l-3.81-79.94c2.85,1.21,4.17,3.2,4.51,10.26,0,0,4.72,56.85,4,61.93A12.26,12.26,0,0,1,896.91,951Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M981,969V794c2.78,1.92,4,4,4,10,0,0,5,155,4,159S981,969,981,969Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M981,969V794c-2.78,1.92-4,4-4,10,0,0-5,155-4,159S981,969,981,969Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M996,865V800c2.78,1.83,3,4.78,3,10.51,0,0,1,46.84,0,50.67S996,865,996,865Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M996,865V800c-2.78,1.83-4,3.82-4,9.56,0,0-2,46.84-1,50.66S996,865,996,865Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1000,972V951c2.78.59,3,1.54,3,3.4,0,0,1,15.13,0,16.36A4.29,4.29,0,0,1,1000,972Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1000,972V951c-2.78.59-4,1.24-4,3.09,0,0-2,15.13-1,16.37S1000,972,1000,972Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M999.09,949l3.81-77c2.64,3.18,2.68,6.74,2.35,13.54,0,0-1.76,55.85-3,60S999.09,949,999.09,949Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M999.09,949l3.81-77c-2.85,1.17-4.17,3.09-4.51,9.88,0,0-4.72,54.77-4,59.66A11.79,11.79,0,0,0,999.09,949Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 51,
    y: 11,
    width: 34,
    height: 27,
    rx: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 51,
    y: 47,
    width: 34,
    height: 27,
    rx: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 51,
    y: 92,
    width: 34,
    height: 65,
    rx: 5.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 51,
    y: 170.55,
    width: 34,
    height: 10.45,
    rx: 5.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M896,832a321.85,321.85,0,0,1,100,0",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M896,869a321.85,321.85,0,0,1,100,0",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M879,953a382.74,382.74,0,0,1,134,0",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1011,881c-1.07-5.55-3.33-9.74-9-10l-13-2v-2l13-1c3.59-.79,5.17-2.69,6-5l-1-20c-1.67-5.28-4-8-11-9l1-2h6c2.82-.44,4.4-1.9,4-5l-1-12c-6-19-36-29-60-30-24,1-54,11-60,30l-1,12c-.4,3.1,1.18,4.56,4,5h6l1,2c-7,1-9.33,3.72-11,9l-1,20c.83,2.31,2.41,4.21,6,5l13,1v2l-13,2c-5.67.26-7.93,4.45-9,10l-2,85c.51,4.82,2.66,7.28,6,8h122c3.34-.72,5.49-3.18,6-8Z",
    transform: "translate(-878 -783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1010.5,881.5c-1.07-5.55-3.33-9.74-9-10l-13-2v-2l13-1c3.59-.79,5.17-2.69,6-5l-1-20c-1.67-5.28-4-8-11-9l1-2h6c2.82-.44,4.4-1.9,4-5l-1-12c-6-19-36-29-60-30-24,1-54,11-60,30l-1,12c-.4,3.1,1.18,4.56,4,5h6l1,2c-7,1-9.33,3.72-11,9l-1,20c.83,2.31,2.41,4.21,6,5l13,1v2l-13,2c-5.67.26-7.93,4.45-9,10l-2,85c.51,4.82,2.66,7.28,6,8h122c3.34-.72,5.49-3.18,6-8Z",
    transform: "translate(-878 -783)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenouilleres);
export default __webpack_public_path__ + "static/media/genouilleres.c38a9e16a67b945ad93c0f528251181d.svg";
export { ForwardRef as ReactComponent };